import React from 'react';

import { DownOutlined } from '@ant-design/icons';
import {
  Button as AntdButton,
  Dropdown as AntdDropdown,
  Menu as AntdMenu,
} from 'antd';

import {
  ConditionsReactivateTypeAutoriteFourriereDto,
  TypeAutoriteFourriereDto,
} from 'lib_api/lib/api/gen';

import { useModal } from 'hooks/modal/useModal';

import ModalDesactivation from '../Modals/ModalDesactivation/ModalDesactivation';
import ModalReactivation from '../Modals/ModalReactivation/ModalReactivation';

import ConditionReactivateTypeAf from './ConditionReactivateTypeAf/ConditionReactivateTypeAf';
import ModalDetails from './Modals/ModalDetails';
import ModalUpdate from './Modals/ModalUpdate';
import { useChangeValidityTypeAf } from './utils';

interface CellDetailsAndActionsProps {
  typeAf: TypeAutoriteFourriereDto;
  refreshDashboard: () => void;
}

function CellDetailsAndActions({
  typeAf: typeAf,
  refreshDashboard,
}: CellDetailsAndActionsProps): React.ReactElement {
  const modalDetails = useModal();
  const modalUpdate = useModal();
  const modalDeprecate = useModal();

  const [
    submitReactivateReferentiel,
    submitDeprecateReferentiel,
    conditionsReactivateReferentiel,
  ] = useChangeValidityTypeAf();

  const conditionUnlock = (
    conditions: ConditionsReactivateTypeAutoriteFourriereDto | undefined,
  ): boolean => {
    return conditions?.reactivationAvailable ?? false;
  };

  const menu = (
    <AntdMenu>
      <AntdMenu.Item onClick={modalUpdate.open}>Modifier</AntdMenu.Item>
      <AntdMenu.Item onClick={modalDeprecate.open}>
        {typeAf.valid
          ? "Désactiver le type d'autorité de fourrière"
          : "Activer le type d'autorité de fourrière"}
      </AntdMenu.Item>
    </AntdMenu>
  );

  return (
    <>
      <AntdButton onClick={modalDetails.open}>Détails</AntdButton>
      <ModalDetails
        typeAf={typeAf}
        visible={modalDetails.visible}
        close={modalDetails.close}
      />
      <ModalUpdate
        typeAutoriteFourriere={typeAf}
        visible={modalUpdate.visible}
        close={modalUpdate.close}
        refreshDashboard={refreshDashboard}
      />
      <AntdDropdown overlay={menu} className="menuActions">
        <AntdButton>
          Actions <DownOutlined />
        </AntdButton>
      </AntdDropdown>
      {modalDeprecate.visible &&
        (typeAf.valid ? (
          <ModalDesactivation
            idCorrelation={typeAf.idCorrelation}
            titleModal="Désactiver le type d'autorité de fourrière"
            submitDeprecate={submitDeprecateReferentiel}
            visible={modalDeprecate.visible}
            close={modalDeprecate.close}
            callAfterSubmit={refreshDashboard}
            usesRequest={undefined}
            componentUses={undefined}
          />
        ) : (
          <ModalReactivation
            idCorrelation={typeAf.idCorrelation}
            titleModal="Réactiver le type d'autorité de fourrière"
            visible={modalDeprecate.visible}
            close={modalDeprecate.close}
            callAfterSubmit={refreshDashboard}
            conditionRequest={conditionsReactivateReferentiel}
            componentConditions={ConditionReactivateTypeAf}
            conditionUnlock={conditionUnlock}
            reactivateRequest={submitReactivateReferentiel}
          />
        ))}
    </>
  );
}

export default CellDetailsAndActions;
